import React, { useState } from 'react';
import { Link } from 'react-router-dom';

/*
  Hooks
*/
import useAuth from '../hooks/useAuth';

/*
  Components
*/
import SnackBar from '../components/SnackBar';
import InputField from '../components/InputField';

const Login = () => {
  const { loginUser, error, setError } = useAuth();
  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');

  const handleFormSubmit = async (e: any) => {
    e.preventDefault();
    await loginUser({
      username,
      password,
    });
  };

  return (
    <>
      {error && (
        <SnackBar
          state={error}
          setState={setError}
          message="Please provide a valid username and password"
          type="error" />
      )}
      <section className="centered">
        <form className="centered__form" onSubmit={handleFormSubmit}>
          <h1 className="form__title">Login</h1>
          <InputField
            state={username}
            setState={setUsername}
            placeholder="Username" />
          <InputField
            state={password}
            setState={setPassword}
            type="password"
            placeholder="Password" />
          <button className="form__btn" type="submit">Login</button>
          <div className="form__link">
            <p>Don’t have an account yet?</p>
            <Link to="/signup">Sign up</Link>
          </div>
        </form>
      </section>
    </>
  );
};

export default Login;
